import React, { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import InfoPage from '.';
import { persistAuthResult } from '../../utils/authHelpers';

const AVAILABLE_PERSONAS = [
  { id: 'creator', label: 'Creator' },
  { id: 'host', label: 'Host' },
  { id: 'traveler', label: 'Traveler' },
];

const MultiPersonaSignup = () => {
  const [searchParams] = useSearchParams();
  const initialPersonas = useMemo(() => {
    const fromUrl = (searchParams.get('personas') || '').split(',').filter(Boolean);
    return fromUrl.length ? fromUrl : ['creator'];
  }, [searchParams]);
  const [personas, setPersonas] = useState(initialPersonas);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const togglePersona = (persona) => {
    setPersonas((prev) => {
      if (prev.includes(persona)) return prev.filter(p => p !== persona);
      return [...prev, persona];
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!personas.length) {
      setError('Choose at least one profile type.');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      const signupRes = await fetch('/api/signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ roles: personas, firstName, lastName, email, password, membershipTier: 'all_access' }),
      });
      const signupData = await signupRes.json();
      if (!signupRes.ok || !signupData.ok) throw new Error(signupData.error || 'signup_failed');
      persistAuthResult({ email, token: signupData.token, user: signupData.user });

      const checkoutRes = await fetch('/api/persona/checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, personas }),
      });
      const checkoutData = await checkoutRes.json();
      if (checkoutRes.ok && checkoutData.ok && checkoutData.url) {
        window.location.href = checkoutData.url;
        return;
      }

      window.location.assign('/dashboard');
    } catch (e) {
      setError(e.message || 'Unable to create your account.');
    } finally {
      setSubmitting(false);
    }
  };

  const below = (
    <div style={{ maxWidth: 720, margin: '64px auto', padding: '0 20px' }}>
      <h1 style={{ color: '#0f084b' }}>Create Your All-Access Login</h1>
      <p style={{ color: '#0f084b', opacity: 0.75 }}>
        Choose the profile types you want on this account. Partner access still requires a separate application.
      </p>

      <form onSubmit={handleSubmit} style={{ display: 'grid', gap: 16, marginTop: 24 }}>
        <div style={{ display: 'grid', gap: 10 }}>
          {AVAILABLE_PERSONAS.map((persona) => (
            <label key={persona.id} style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              <input type="checkbox" checked={personas.includes(persona.id)} onChange={() => togglePersona(persona.id)} />
              {persona.label}
            </label>
          ))}
          <button className="button-stroke" type="button" onClick={() => window.location.assign('/partner-signup')}>
            Apply to become a Partner
          </button>
        </div>

        <input className="login-input" placeholder="First name" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
        <input className="login-input" placeholder="Last name" value={lastName} onChange={(e) => setLastName(e.target.value)} required />
        <input className="login-input" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <input className="login-input" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />

        <button className="button" type="submit" disabled={submitting}>
          {submitting ? 'Creating account...' : 'Continue to checkout'}
        </button>
        {error && <div style={{ color: '#dc1d08' }}>{error}</div>}
      </form>
    </div>
  );

  return <InfoPage title="" below={below} disableStamps />;
};

export default MultiPersonaSignup;
